import { Component, ViewChild } from '@angular/core';
import { IonTabs, NavController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';
import { EventService } from '../services/event.service';

@Component({
  selector: 'app-tabs-transportec',
  templateUrl: 'tabs-transportec.page.html',
  styleUrls: ['tabs-transportec.page.scss'],
})
export class TabsTransportecPage {
  @ViewChild('tabs') tabs: IonTabs;
  transportec = false;
  subscribed = false;

  constructor(private navCtrl: NavController, private authService: AuthService, private eventService: EventService) {
    this.eventService.watch.subscribe((value) => {
      if (value === 'campus:change') {
        this.checkUser();
      }
      if (value === 'transportec:subscribed') {
        this.subscribed = true;
      }
    });

    this.checkUser();
    // this.transportec = true;
  }

  checkUser() {
    this.authService.canTransportec().then((canTransportec) => {
      if (canTransportec) {
        this.transportec = true; // true;
        this.checkSubscribed();
      } else {
        this.transportec = false;
      }
    });
  }

  checkSubscribed() {
    this.authService.getSubscription().then((res) => {
      if (res && res.school_period) {
        const registrationEndDate = new Date(res.school_period.regular_registration_end_date);
        const now = new Date();
        console.log(now + ' < ' + registrationEndDate + ' = ' + (now < registrationEndDate));
        if (res && (res.status === 1 || res.name === 'PV' || now > registrationEndDate)) {
          console.log('Show transportec view.');
          this.subscribed = true;
        } else {
          this.subscribed = false;
        }
      }
    });
  }

  async openTab(tab: string, evt: MouseEvent) {
    const tabSelected = this.tabs.getSelected();
    evt.stopImmediatePropagation();
    evt.preventDefault();
    return tabSelected !== tab
      ? await this.navCtrl.navigateRoot(this.tabs.outlet.tabsPrefix + '/' + tab)
      : this.tabs.select(tab);
  }
}
